import * as React from 'react';
import { ListHeader } from "../../internal/list";
import { useMenuContext } from "../useMenuContext";
import { getMenuHeaderStyles } from "./MenuHeader.styles";
export var MenuHeader = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children;

  var _useMenuContext = useMenuContext(),
      palette = _useMenuContext.palette;

  var styles = getMenuHeaderStyles({
    palette: palette
  });
  return /*#__PURE__*/React.createElement(ListHeader, {
    ref: ref,
    sx: styles
  }, children);
});
MenuHeader.displayName = 'MenuHeader';